/** The Feed page's search: a `project` an alert email opens in the drawer. Old filter params are dropped. */
export interface FeedSearch {
  project?: string;
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Keeps a well-formed project id; anything else is dropped. */
export function validateFeedSearch(search: Record<string, unknown>): FeedSearch {
  const { project } = search;
  return typeof project === 'string' && UUID.test(project)
    ? { project: project.toLowerCase() }
    : {};
}

/** Where an old Notifications or Home link lands: the Feed, search kept. */
export function legacyFeedTarget(searchStr: string, workspaceSlug: string | null): string {
  const base = workspaceSlug ? `/${encodeURIComponent(workspaceSlug)}/feed` : '/feed';
  return `${base}${searchStr}`;
}
